import React from 'react';
import { Link } from 'react-router-dom';

const HomeFeaturedProjectsSection = ({ featuredError, featuredProjects, featuredStatus }) => {
  return (
    <section id="projects" aria-labelledby="projects-title" className="site-bg-section py-20 px-6">
      <div className="container mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2
            id="projects-title"
            className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
          >
            Projetos em destaque
          </h2>
          <p className="mt-4 text-lg text-gray-600">Uma seleção dos meus trabalhos recentes.</p>
        </div>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredStatus === 'loading' && (
            <div className="col-span-full text-center text-gray-600">
              Loading featured projects...
            </div>
          )}
          {featuredStatus === 'error' && (
            <div className="col-span-full text-center text-red-600">{featuredError}</div>
          )}
          {featuredStatus === 'success' && featuredProjects.length === 0 && (
            <div className="col-span-full text-center text-gray-600">
              No featured projects available yet.
            </div>
          )}
          {featuredStatus === 'success' &&
            featuredProjects.map((project) => (
              <div
                key={project.id}
                className="bg-white rounded-lg border border-gray-200 shadow-lg site-card overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 hover:shadow-xl"
              >
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                  <p className="text-gray-600 mb-4">{project.description}</p>
                  <a
                    href={project.repoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold text-blue-600 hover:underline"
                  >
                    View on GitHub &rarr;
                  </a>
                </div>
              </div>
            ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/projects" className="text-lg font-semibold text-blue-600 hover:underline">
            View All Projects
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeFeaturedProjectsSection;
